export default function CTASection() {
  return (
    <section className="relative py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Image Banner */}
        <div className="relative w-full h-[300px] md:h-[400px] rounded-2xl overflow-hidden mb-12">
          <img
            src="https://readdy.ai/api/search-image?query=Wide%20panoramic%20shot%20of%20organized%20creative%20workspace%20with%20laptop%20displaying%20spreadsheet%20data%20open%20notebook%20coffee%20cup%20and%20scattered%20fashion%20accessory%20inspiration%20items%20on%20light%20oak%20desk%2C%20bright%20natural%20window%20light%20from%20right%20side%2C%20productive%20morning%20atmosphere%2C%20warm%20inviting%20startup%20office%20aesthetic%2C%20shallow%20depth%20of%20field%2C%20no%20text%20no%20logos%20no%20faces&width=1400&height=700&seq=cta-banner-v2-003&orientation=landscape"
            alt="AllChinaBuy Spreadsheet community shopping workspace"
            className="w-full h-full object-cover"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/25 via-transparent to-transparent"></div>
        </div>

        {/* Text & Buttons */}
        <div className="text-center max-w-3xl mx-auto">
          <p className="font-heading text-2xl md:text-3xl lg:text-4xl text-foreground-900 leading-relaxed mb-4">
            The AllChinaBuy Spreadsheet is the{' '}
            <span className="italic text-primary-500">best way</span>{' '}
            to find{' '}
            <span className="font-bold">verified</span>{' '}
            products.
          </p>
          <p className="text-foreground-500 text-sm md:text-base mb-10 leading-relaxed">
            Ready to explore the best AllChinaBuy Spreadsheet? Browse thousands of community finds, QC guides, and shopping tutorials — all in one place.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="group bg-foreground-900 text-white text-sm md:text-base font-semibold px-10 py-4 rounded-full hover:bg-foreground-800 transition-all flex items-center gap-2 whitespace-nowrap cursor-pointer w-full sm:w-auto justify-center"
            >
              AllChinaBuy Spreadsheet
              <i className="ri-arrow-right-up-line group-hover:translate-x-1 transition-transform"></i>
            </a>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="group border-2 border-foreground-900 text-foreground-900 text-sm md:text-base font-semibold px-10 py-4 rounded-full hover:bg-foreground-900 hover:text-white transition-all flex items-center gap-2 whitespace-nowrap cursor-pointer w-full sm:w-auto justify-center"
            >
              Buy It Now
              <i className="ri-shopping-cart-line group-hover:translate-x-1 transition-transform"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}